import React from 'react';
import { Formik, Form } from 'formik';
import { PLRFormProps } from '../../../../../../types/preloan';
import { FormSchemaV3 } from '../../../../../../types/preloan/v3';
import ExperianForm from './components/ExperianForm';
import {
  patchDependentStatus,
  patchManualVerification,
  postExperianChallenge,
  postExperianChallengeResponses,
} from '../../../../../../queries/preloan/v3';
import { preLoanRequestStep } from '../../formLogic';

export default function NeedsICPForm<T extends FormSchemaV3>(props: PLRFormProps<T>) {
  const {
    formRef,
    formSchema,
    handleEnableLoading,
    handleNext,
    handleCurrentData,
    handleStep,
  } = props;

  React.useEffect(() => handleEnableLoading(true), []);

  const handleUnemployedFallback = async () => {
    const res = await patchDependentStatus({ token: formSchema.PLRtoken, workerType: 'UNEMPLOYED' });
    const { data } = res;
    handleCurrentData({
      ...formSchema,
      step: data.plr.step,
      adminComment: data.plr.adminComment,
      firstName: data.plr.firstName,
      lastName: data.plr.lastName,
      rut: data.plr.idNumber,
      origin: data.plr.origin,
      results: data.results,
    });
    return handleStep(preLoanRequestStep.ARCHIVED_FAIL);
  };

  const patchManualVerificationAction = async () => {
    const res = await patchManualVerification({ token: formSchema.PLRtoken });
    const { data } = res;
    switch (data.plr.step) {
      case 'ARCHIVED_FAIL': {
        handleCurrentData({
          ...formSchema,
          step: data.plr.step,
          firstName: data.plr.firstName,
          lastName: data.plr.lastName,
          rut: data.plr.idNumber,
          results: data.results,
          origin: data.plr.origin,
          adminComment: data.plr.adminComment,
        });
        return handleStep(preLoanRequestStep.ARCHIVED_FAIL);
      }
      default:
        handleCurrentData({
          ...formSchema,
          step: data.plr.step,
          needsPensionStatement: data.plr.needsPensionStatement,
          needsSettlement: data.plr.needsSettlement,
          settlementsRequired: data.settlementsRequired,
          pensionStatementsRequired: data.pensionStatementsRequired,
        });
        return handleStep(preLoanRequestStep.UPLOAD_DOCUMENTS);
    }
  };

  return (
    <Formik
      innerRef={formRef}
      initialValues={formSchema}
      onSubmit={() => handleNext()}
    >
      {({ values, handleChange, setFieldValue }) => (
        <Form>
          <ExperianForm
            values={values}
            handleChange={handleChange}
            queriesArray={[postExperianChallenge, postExperianChallengeResponses]}
            setFieldValue={setFieldValue}
            handleCurrentData={handleCurrentData}
            handleStep={handleStep}
            handleEnableLoading={handleEnableLoading}
            handleUnemployedFallback={handleUnemployedFallback}
            patchManualVerificationFallback={patchManualVerificationAction}
          />
        </Form>
      )}

    </Formik>
  );
}
